import { IconSVGProps } from '@clover-web-lib-sprout/common';
import cx from 'clsx';
import React, { FC } from 'react';
import styles from './styles.module.scss';

export type IconProps = {
  IconSVG?: React.FC<IconSVGProps>;
  icon?: React.ReactElement<React.SVGProps<SVGSVGElement>>;
  accessibleName: string;
  /** (optional) img = decorative; document = informational; application = interactive */
  role?: 'img' | 'application' | 'document';
  testId?: string;
  className?: string;
  noBorder?: boolean;
  idFor?: string;
  isDisabled?: boolean;
};

export const Icon: FC<IconProps> = ({
  IconSVG,
  icon,
  accessibleName,
  role = 'img',
  className,
  testId,
  noBorder,
  isDisabled,
  idFor,
}) => {
  return (
    <span
      className={cx(styles.icon, className, {
        [styles.noBorder]: noBorder,
        [styles.externalIconDisabled]: !!icon && isDisabled,
      })}
      data-testid={testId}
    >
      {IconSVG ? <IconSVG aria-hidden={true} focusable={false} role={role} /> : icon}
      {idFor ? (
        <label htmlFor={idFor} className={styles.visuallyHidden}>
          {accessibleName}
        </label>
      ) : (
        <span className={styles.visuallyHidden}>{accessibleName}</span>
      )}
    </span>
  );
};
